/*
    创建者：shuxiaokai
    创建时间：2020-05-11 15:02
    模块名称：待拖拽组件
    备注：xxxx
*/
<template>
    <div class="s-select-widget">
        <div class="preview">
            <slot name="preview"></slot>
        </div>
        <div class="label text-ellipsis">
            {{ label }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: ""
        },
    },
    data() {
        return {

        };
    },
    created() {

    },
    methods: {
        //=====================================获取远程数据==================================//

        //=====================================前后端交互====================================//

        //=====================================组件间交互====================================//  
        
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">
    .s-select-widget {
        margin-right: size(10);
        margin-bottom: size(10);
        width: size(100);
        height: size(100);
        border: 1px solid $gray-300;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        border-radius: $border-radius-base;
        .preview {
            cursor: pointer;
            width: size(100);
            height: size(80);
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
